module.exports = __webpack_public_path__ + "img/icon_sb_unselect_star_reseller_t.2283a00.svg";